import AddIcon from "@mui/icons-material/Add";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import WorkspaceIcon from "@mui/icons-material/DesktopWindows";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Autocomplete,
  Button,
  InputLabel,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  FormControl,
  MenuItem,
  Checkbox,
  useTheme,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";

import {
  buildTree,
  findObjectInChildren,
  listAllParents,
} from "../../../../../containers/DocumentsSmartDocz/Wizard/helpers";
import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import {
  useDoczClients,
  useDoczMetadados,
  useDoczPasta,
  useDoczProjects,
} from "../../../../../hooks/docz";
import { language } from "../../../../../language";
import { getUniqueDocumentServiceFields } from "../../../../../util/camundaPropertiesPanelUtils";
import GenericModal from "../../../../modal-closebtn";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const FormPadding = styled("div")(({ theme }) => ({
  padding: "1% 1%",
}));

const FormControlStyled = styled(FormControl)(({ theme }) => ({
  width: "100%",
  marginTop: "2%",
}));

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.main,
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const Title = styled(InputLabel)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

const METADADOS_DE_ARQUIVO = [
  "Tipologia",
  "Local Digitalização",
  "Titulo",
  "Assunto",
  "Sigiloso",
  "Observação",
  "Data Documento",
  "Local Produção",
  "Autor",
];

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const RenderTree = (nodes, theme) => {
  return (
    <TreeItem
      classes={{
        content: {
          borderTopRightRadius: theme?.spacing(2),
          borderBottomRightRadius: theme?.spacing(2),
          paddingRight: theme?.spacing(1),
          fontWeight: theme?.typography?.fontWeightMedium,
          width: "880px",
          height: "34px",
        },
      }}
      key={String(nodes.id)}
      itemId={String(nodes.id)}
      label={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: theme?.spacing(0.5, 0),
          }}
        >
          {nodes.isProjeto ? (
            <WorkspaceIcon
              style={{
                marginRight: theme?.spacing(1),
                fontSize: 26,
                color: "rgba(0, 0, 0, 0.54)",
              }}
            />
          ) : (
            <FolderIcon
              style={{
                marginRight: theme?.spacing(1),
                fontSize: 26,
                color: "rgba(0, 0, 0, 0.54)",
              }}
            />
          )}
          <Typography
            variant="body1"
            style={{ fontWeight: "inherit", flexGrow: 1 }}
          >
            {nodes.name}
          </Typography>
        </div>
      }
    >
      {nodes.children && nodes.children.length > 0 ? (
        nodes.children.map((childNode) => {
          return RenderTree(childNode, theme);
        })
      ) : (
        <TreeItem
          itemId={`${nodes.id}-placeholder`}
          label=""
          style={{ display: "none" }}
        />
      )}
    </TreeItem>
  );
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  doczProjetoList,
  treeData,
  treeExpanded,
  handleExpandTreeFolder,
  handleChangeProjeto,
  handleChangeConfigFields,
  handleSelectTreeFolder,
  taskFields,
  businessObject,
}) {
  const idProjeto = jsonConfig?.idProjeto || "";
  const doczFolderPath = jsonConfig?.doczFolderPath || "";
  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const allFormFieldIds = (taskFields || []).map((f) => f?.id).filter(Boolean);

  const theme = useTheme();

  return (
    <>
      <Grid
        item
        size={12}
        sx={{ height: "29px", marginBottom: "30px", marginTop: "20px" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "700" }}>
          {language.storageLocationInDocz}
        </Typography>
      </Grid>

      <Grid
        item
        size={12}
        container
        spacing={3}
        sx={{ marginTop: "16px" }}
        wrap="wrap"
      >
        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            required
            fullWidth
            id="clientDocz"
            name="clientDocz"
            label={language.client}
            value={jsonConfig?.nomeCliente || ""}
            onChange={handleChangeConfigFields}
            variant="outlined"
            disabled
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
          <TextField
            select
            required
            variant="outlined"
            id="idProjeto"
            name="idProjeto"
            label={language.project}
            fullWidth
            value={String(idProjeto)}
            onChange={handleChangeProjeto}
            renderValue={(value) => {
              if (!value) {
                return "";
              }
              const selectedItem = Array.isArray(doczProjetoList)
                ? doczProjetoList.find((item) => String(item.id) === value)
                : null;
              return (
                <Typography variant="body1" color="primary">
                  {selectedItem?.name}
                </Typography>
              );
            }}
          >
            {Array.isArray(doczProjetoList) &&
              doczProjetoList.length > 0 &&
              doczProjetoList.map((item) => {
                return (
                  <MenuItem key={item.id} value={String(item.id)}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>
      </Grid>

      <Grid
        container
        size={12}
        spacing={3}
        sx={{ marginTop: "8px" }}
        wrap="wrap"
      >
        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
          <Tooltip
            title={language.doczModalMultiDocsCheckBoxToolTip}
            placement="right"
          >
            <FormControlLabel
              style={{ marginTop: "10px" }}
              control={
                <Checkbox
                  color="primary"
                  name="sendMultiDocs"
                  checked={Boolean(jsonConfig?.sendMultiDocs)}
                  onChange={handleChangeConfigFields}
                />
              }
              label={language.doczModalMultiDocsCheckBox}
            />
          </Tooltip>
        </Grid>

        <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
          <Tooltip title={language.multiDocsDoczModalToolTip} placement="right">
            <Autocomplete
              id="multiDocsField"
              options={allFormFieldIds}
              getOptionLabel={(opt) => opt}
              value={jsonConfig?.multiDocsField || null}
              onChange={(e, newValue) => {
                handleChangeConfigFields({
                  target: {
                    name: "multiDocsField",
                    value: newValue || "",
                    type: "text",
                  },
                });
              }}
              disabled={Boolean(jsonConfig?.sendMultiDocs)}
              clearOnEscape
              fullWidth
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={language.multiDocsField}
                  variant="outlined"
                  placeholder={language.selectFormFieldId}
                />
              )}
            />
          </Tooltip>
        </Grid>
      </Grid>

      <Grid item size={12} sx={{ marginTop: "60px" }}>
        <Typography variant="body1" sx={{ fontWeight: "700" }}>
          {language.navigateTreeAndSelect}
        </Typography>
      </Grid>

      <Grid
        item
        size={12}
        container
        spacing={3}
        sx={{
          marginTop: "10px",
          marginBottom: "10px",
          minHeight: "200.74px",
          overflow: "auto",
        }}
      >
        <Grid item size={12}>
          <div style={{ width: "100%" }}>
            <SimpleTreeView
              defaultCollapseIcon={<ExpandMoreIcon />}
              defaultExpandIcon={<ChevronRightIcon />}
              expandedItems={treeExpanded}
              onItemSelectionToggle={(e, node) =>
                handleSelectTreeFolder(e, node)
              }
              onExpandedItemsChange={(event, nodeIds) =>
                handleExpandTreeFolder(event, nodeIds)
              }
            >
              {treeData?.length > 0 ? (
                treeData.map((node) => RenderTree(node, theme))
              ) : (
                <Grid
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                  style={{ display: "flex" }}
                >
                  <Typography
                    variant="body1"
                    style={{ marginTop: "35px", fontWeight: "400" }}
                  >
                    {language.noFolderSelected}
                  </Typography>
                </Grid>
              )}
            </SimpleTreeView>
          </div>
        </Grid>
      </Grid>

      <Grid item size={12}>
        <FormControlStyled margin="normal">
          <TextField
            required
            id="doczFolderPath"
            name="doczFolderPath"
            label={language.pathUntilFolder}
            value={doczFolderPath}
            onChange={handleChangeConfigFields}
            variant="outlined"
          />
        </FormControlStyled>
      </Grid>
    </>
  );
}

// TABa Configuration
function TabConfiguration({
  jsonConfig,
  doczMetadadoList,
  handleChangeDocumentos,
  handleChangeMetadados,
  addMetadados,
  removeMetadados,
  taskFields,
  businessObject,
}) {
  const documentos = jsonConfig?.documentos || [];
  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const metadados = jsonConfig?.metadados || [];
  const arquivoMetadados = jsonConfig?.arquivoMetadados || [];
  const formFieldsVariables =
    taskFields?.filter(
      (taskField) =>
        !documentVariables.some((docItem) => docItem === taskField.id),
    ) || [];

  return (
    <>
      <Grid
        item
        size={{ xs: 12 }}
        sx={{ height: "29px", marginBottom: "30px", marginTop: "20px" }}
      >
        <Typography variant="h6" sx={{ fontWeight: "550" }}>
          {language.documentsToSend}
        </Typography>
      </Grid>

      <Grid item size={{ xs: 12 }}>
        <Autocomplete
          value={documentos}
          onChange={handleChangeDocumentos}
          multiple
          id="document-list"
          options={documentVariables}
          getOptionLabel={(fileField) => fileField}
          filterSelectedOptions
          getOptionSelected={(option, value) => option === value}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              required={
                !(
                  jsonConfig?.sendMultiDocs ||
                  (jsonConfig?.multiDocsField &&
                    jsonConfig.multiDocsField.trim().length > 0)
                )
              }
              label={language.documentsToUpload}
            />
          )}
        />
      </Grid>

      <Grid container sx={{ marginBottom: "30px", marginTop: "45px" }}>
        <Typography variant="h6" sx={{ fontWeight: "550" }}>
          {language.metadataForRegisteringDC}
        </Typography>
      </Grid>

      <Grid container spacing={3} style={{}}>
        {metadados && metadados.length > 0 ? (
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.sourceSmartdocs}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.destinationDocz}*
              </Typography>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 2 }}
              justifyContent="center"
              alignItems="center"
              sx={{ display: "flex" }}
            >
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.groupIfFound}
              </Typography>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 2 }}
              justifyContent="center"
              alignItems="center"
              sx={{ display: "flex" }}
            >
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.isADate}
              </Typography>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 2 }}
              justifyContent="center"
              alignItems="center"
              sx={{ display: "flex" }}
            >
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.addRemove}
              </Typography>
            </Grid>
            {metadados.map((m, index) => {
              if (m.hidden) return null;

              return (
                <Fragment key={`m${index}_${m.da}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        select
                        required
                        variant="outlined"
                        id="valor"
                        name="valor"
                        label={language.sourceSmartdocs}
                        value={metadados[index]?.valor || ""}
                        onChange={(event) =>
                          handleChangeMetadados(event, index, "metadados")
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {formFieldsVariables &&
                          formFieldsVariables?.map((fv) => {
                            return (
                              <MenuItem key={fv.id} value={fv.id}>
                                {fv.id}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        select
                        required
                        variant="outlined"
                        id="nome"
                        name="nome"
                        label={language.destinationDocz}
                        value={metadados[index]?.nome || ""}
                        onChange={(event) =>
                          handleChangeMetadados(event, index, "metadados")
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {doczMetadadoList &&
                          doczMetadadoList?.map((doczM) => {
                            return (
                              <MenuItem
                                key={`${doczM.id}_${doczM.nome}`}
                                value={doczM.nome}
                              >
                                {doczM.nome}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ display: "flex" }}
                  >
                    <FormControl sx={{ width: "100%" }}>
                      <Checkbox
                        name="usarNaBusca"
                        onChange={(event) =>
                          handleChangeMetadados(event, index, "metadados")
                        }
                        value={metadados[index]?.usarNaBusca || false}
                        checked={metadados[index]?.usarNaBusca || false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ display: "flex" }}
                  >
                    <FormControl sx={{ width: "100%" }}>
                      <Checkbox
                        name="isDate"
                        onChange={(event) =>
                          handleChangeMetadados(event, index, "metadados")
                        }
                        value={metadados[index]?.isDate || false}
                        checked={metadados[index]?.isDate || false}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ display: "flex" }}
                  >
                    <IconButton
                      size="small"
                      color="primary"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) =>
                        removeMetadados(event, index, "metadados")
                      }
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={{ xs: 12 }}
            justifyContent="center"
            alignItems="center"
            sx={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noMetadataSelected}
            </Typography>
          </Grid>
        )}
        <Grid item size={{ xs: 12, sm: 6, md: 10 }}></Grid>
        <Grid
          item
          size={{ xs: 12, sm: 6, md: 2 }}
          justifyContent="center"
          alignItems="center"
          sx={{ display: "flex" }}
        >
          <IconButtonStyled
            size="small"
            color="primary"
            onClick={() => addMetadados("metadados")}
          >
            <AddIcon />
          </IconButtonStyled>
        </Grid>
      </Grid>

      <Grid container sx={{ marginBottom: "30px", marginTop: "45px" }}>
        <Typography variant="h6" sx={{ fontWeight: "550" }}>
          {language.metadataForIndexingFile}
        </Typography>
      </Grid>

      <Grid container spacing={3} style={{}}>
        {arquivoMetadados && arquivoMetadados.length > 0 ? (
          <>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.sourceSmartdocs}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.destinationDocz}*
              </Typography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.digitalDocumentsFiles}
              </Typography>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 6, md: 2 }}
              justifyContent="center"
              alignItems="center"
              sx={{ display: "flex" }}
            >
              <Typography variant="body1" style={{ fontWeight: "410" }}>
                {language.addRemove}
              </Typography>
            </Grid>
            {arquivoMetadados.map((m, index) => {
              return (
                <Fragment key={`m${index}_${m.da}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        select
                        required
                        variant="outlined"
                        id="valor"
                        name="valor"
                        label={language.sourceSmartdocs}
                        value={arquivoMetadados[index]?.valor || ""}
                        onChange={(event) =>
                          handleChangeMetadados(
                            event,
                            index,
                            "arquivoMetadados",
                          )
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {formFieldsVariables &&
                          formFieldsVariables?.map((fv) => {
                            return (
                              <MenuItem key={fv.id} value={fv.id}>
                                {fv.id}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        select
                        required
                        variant="outlined"
                        id="nome"
                        name="nome"
                        label={language.destinationDocz}
                        value={arquivoMetadados[index]?.nome || ""}
                        onChange={(event) =>
                          handleChangeMetadados(
                            event,
                            index,
                            "arquivoMetadados",
                          )
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {METADADOS_DE_ARQUIVO &&
                          METADADOS_DE_ARQUIVO?.map((arqMet) => {
                            return (
                              <MenuItem key={`${arqMet}`} value={arqMet}>
                                {arqMet}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormControl sx={{ width: "100%" }}>
                      <TextField
                        select
                        required
                        variant="outlined"
                        id="arquivo"
                        name="arquivo"
                        label={language.Document}
                        value={arquivoMetadados[index]?.arquivo || ""}
                        onChange={(event) =>
                          handleChangeMetadados(
                            event,
                            index,
                            "arquivoMetadados",
                          )
                        }
                        renderValue={(value) => {
                          if (!value) {
                            return "";
                          }
                          return (
                            <Typography variant="body1" color="primary">
                              {value}
                            </Typography>
                          );
                        }}
                      >
                        {documentVariables &&
                          documentVariables?.map((docVar) => {
                            return (
                              <MenuItem key={docVar} value={docVar}>
                                {docVar}
                              </MenuItem>
                            );
                          })}
                      </TextField>
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 2 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ display: "flex" }}
                  >
                    <IconButton
                      size="small"
                      color="primary"
                      style={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) =>
                        removeMetadados(event, index, "arquivoMetadados")
                      }
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={{ xs: 12 }}
            justifyContent="center"
            alignItems="center"
            sx={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noMetadataSelected}
            </Typography>
          </Grid>
        )}
        <Grid item size={{ xs: 12, sm: 6, md: 10 }}></Grid>
        <Grid
          item
          size={{ xs: 12, sm: 6, md: 2 }}
          justifyContent="center"
          alignItems="center"
          sx={{ display: "flex" }}
        >
          <IconButtonStyled
            size="small"
            color="primary"
            onClick={() => addMetadados("arquivoMetadados")}
          >
            <AddIcon />
          </IconButtonStyled>
        </Grid>
      </Grid>
    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarDoczDocumento({
  saveIntegrarDoczConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
}) {
  const [jsonConfig, setJsonConfig] = useState({
    idProjeto: "",
    idEtiqueta: "",
    documentos: [],
    descricao: "",
    departamento: "",
    metadados: [],
    doczFolderTree: [],
    idCliente: "",
    nomeCliente: "",
    doczFolderPath: "",
    arquivoMetadados: [],
  });

  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "xl",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [treeData, setTreeData] = useState([]);
  const [treeLoading, setTreeLoading] = useState(false);
  const [treeExpanded, setTreeExpanded] = useState([]);
  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);

  const { data: doczClienteList, refetch: fetchDoczClienteList } =
    useDoczClients({
      enabled: false,
    });

  const { data: doczProjetoList, refetchWithParams: fetchDoczProjetoList } =
    useDoczProjects({
      enabled: false,
      params: { idCliente: jsonConfig?.idCliente },
    });

  const { data: doczMetadadoList, refetchWithParams: fetchDoczMetadadoList } =
    useDoczMetadados({
      enabled: false,
      params: { idCliente: jsonConfig?.idCliente },
    });

  const { data: doczPastaList, refetchWithParams: fetchDoczPastaList } =
    useDoczPasta({
      enabled: false,
    });

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        idProjeto: inputValues?.idProjeto,
        idEtiqueta: inputValues?.idEtiqueta,
        documentos: inputValues?.documentos,
        descricao: inputValues?.descricao,
        departamento: inputValues?.departamento,
        metadados: inputValues?.metadados,
        idCliente: inputValues?.idCliente,
        nomeCliente: inputValues?.nomeCliente,
        doczFolderTree: inputValues?.doczFolderTree,
        doczFolderPath: inputValues?.doczFolderTree?.join("/"),
        sendMultiDocs: Boolean(inputValues?.sendMultiDocs),
        multiDocsField: inputValues?.sendMultiDocs
          ? ""
          : inputValues?.multiDocsField || "",
        arquivoMetadados: inputValues?.arquivoMetadados,
      });
    }
  }, [inputValues]);

  // EFFECT 1 - Lista docz cliente
  useEffect(() => {
    fetchDoczClienteList();
  }, [fetchDoczClienteList]);

  // EFFECT 2 - Preenche o cliente
  useEffect(() => {
    if (!doczClienteList) return;

    if (doczClienteList.length > 0) {
      const idCliente = doczClienteList[0].idCliente;
      const nomeCliente = doczClienteList[0].nomeCliente;
      setJsonConfig((prev) => ({
        ...prev,
        idCliente,
        nomeCliente,
      }));
    }
  }, [doczClienteList]);

  // EFFECT 3 - lista docz projetos pelo cliente
  useEffect(() => {
    if (!jsonConfig || !jsonConfig.idCliente || !doczClienteList) return;

    fetchDoczProjetoList({
      idCliente: jsonConfig.idCliente,
    });
  }, [jsonConfig?.idCliente, doczClienteList]);

  // EFFECT 4 - monta arvore
  useEffect(() => {
    if (!jsonConfig?.idProjeto) return;

    const projetoValue =
      doczProjetoList &&
      doczProjetoList.find(
        (v) => String(v.id) === String(jsonConfig.idProjeto),
      );
    if (projetoValue) {
      setTreeData([
        {
          id: String(projetoValue.id),
          name: projetoValue.name,
          isProjeto: true,
          parent: null,
          children: [],
        },
      ]);

      fetchDoczMetadadoList({
        idProjeto: projetoValue.id,
      });
    }
  }, [jsonConfig?.idProjeto]);

  // EFFECT - adiciona lista de pastas na arvore
  useEffect(() => {
    if (!doczPastaList) return;

    if (state?.currentFolderSelected) {
      const doczChildren = doczPastaList.map((p) => {
        const parentId = p.parentId
          ? p.parentId
          : state.currentFolderSelected.id;
        return {
          id: String(p.id),
          name: p.name,
          isProjeto: false,
          parent: { id: String(parentId) },
          children: [],
        };
      });

      buildTree(treeData, doczChildren, state?.currentFolderSelected.id);
      setTreeData(treeData);
    }
  }, [doczPastaList]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const validateConfig = (obj) => {
    const erros = [];
    const documentosObrigatorios = !(
      obj.sendMultiDocs === true ||
      (obj.multiDocsField && obj.multiDocsField.trim().length > 0)
    );

    if (!obj.idProjeto) {
      erros.push(language.destinationProjectRequired);
    }

    if (!obj.doczFolderTree || obj.doczFolderTree.length <= 0) {
      erros.push(language.projectRepositoryRequired);
    }

    if (!obj.doczFolderTree || obj.doczFolderTree.length <= 1) {
      erros.push(language.subfolderInRepositoryRequired);
    }

    if (
      documentosObrigatorios &&
      (!obj.documentos || obj.documentos.length <= 0)
    ) {
      erros.push(language.selectAtLeastOneDocumentToSend);
    }

    if (!obj.metadados || obj.metadados.length <= 0) {
      erros.push(language.selectAtLeastOneMetadataForIntegration);
    }

    if (obj.metadados?.length) {
      if (
        obj.metadados.filter((m) => (!m.nome || !m.valor) && !m.hidden).length >
        0
      ) {
        erros.push(language.fillOrRemoveEmptyMetadataRelationships);
      }
    }

    if (obj.arquivoMetadados?.length) {
      if (
        obj.arquivoMetadados.filter((m) => !m.nome || !m.valor || !m.arquivo)
          .length > 0
      ) {
        erros.push(language.fillOrRemoveEmptyFileMetadataRelationships);
      }
    }

    return erros;
  };

  const handleSave = () => {
    const doczFolderTree =
      jsonConfig?.doczFolderPath?.trim().length > 0
        ? jsonConfig?.doczFolderPath?.trim().split("/")
        : [];

    const idProjeto = jsonConfig?.idProjeto;
    const idEtiqueta = jsonConfig?.idEtiqueta;
    const descricao = jsonConfig?.descricao || null;
    const departamento = jsonConfig?.departamento || null;
    const documentos = jsonConfig?.documentos || [];
    const metadados = jsonConfig?.metadados || [];
    const idCliente = jsonConfig?.idCliente;
    const sendMultiDocs = jsonConfig?.sendMultiDocs || false;
    const multiDocsField = jsonConfig?.sendMultiDocs
      ? ""
      : jsonConfig?.multiDocsField || "";
    const arquivoMetadados = jsonConfig?.arquivoMetadados || [];

    const inputObject = {
      idProjeto,
      idEtiqueta,
      descricao,
      departamento,
      documentos,
      metadados,
      idCliente,
      doczFolderTree,
      sendMultiDocs,
      multiDocsField,
      arquivoMetadados,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //adicionando metadados default
      if (!inputObject.metadados.find((m) => m.nome === "Status")) {
        inputObject.metadados.push({
          nome: "Status",
          valorDefault: "ARQUIVADO",
          usarNaBusca: false,
          hidden: true,
        });
      }

      //salvando no modeler
      saveIntegrarDoczConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeProjeto = (event) => {
    const { value } = event.target;

    // list pastas
    const projetoValue =
      doczProjetoList &&
      doczProjetoList?.find((p) => String(p.id) === String(value));

    setJsonConfig((prev) => ({
      ...prev,
      idProjeto: String(value),
    }));

    if (projetoValue) {
      // reinicia arvore
      setTreeData([
        {
          id: String(projetoValue.id),
          name: projetoValue.name,
          isProjeto: true,
          parent: null,
          children: [],
        },
      ]);

      setTreeExpanded([]);

      // lista metadados
      fetchDoczMetadadoList({
        idProjeto: projetoValue.id,
      });
    }
  };

  const handleChangeConfigFields = (event) => {
    const { name, value, type, checked } = event.target;
    setJsonConfig((prev) => {
      if (name === "sendMultiDocs") {
        const nextSend = type === "checkbox" ? checked : Boolean(value);
        return {
          ...prev,
          sendMultiDocs: nextSend,
          multiDocsField: nextSend ? "" : prev.multiDocsField, // (1) se true, zera
        };
      }
      if (name === "multiDocsField") {
        const nextValue = value;
        return {
          ...prev,
          multiDocsField: nextValue,
          sendMultiDocs:
            nextValue && nextValue.trim().length > 0
              ? false
              : prev.sendMultiDocs, // (2) se tiver valor, força false
        };
      }
      return { ...prev, [name]: type === "checkbox" ? checked : value };
    });
  };

  const handleSelectTreeFolder = (event, nodeIds) => {
    const nodeObject = findObjectInChildren(treeData, nodeIds);

    if (nodeObject) {
      // tree path
      const docParents = listAllParents(treeData, nodeObject);
      docParents.push(nodeObject);

      const doczFolderTreeNames = docParents.map((d) => d.name);
      const docPath = doczFolderTreeNames.join("/");

      setJsonConfig((prev) => ({
        ...prev,
        doczFolderTree: doczFolderTreeNames,
        doczFolderPath: docPath,
      }));

      if (
        nodeObject.isProjeto &&
        String(nodeObject.id) !== String(state?.currentFolderSelected?.id) &&
        !treeExpanded.includes(String(nodeObject.id))
      ) {
        fetchDoczPastaList({
          idProjeto: nodeObject.id,
        });
      }

      setState((prev) => ({
        ...prev,
        currentFolderSelected: nodeObject,
      }));
    }
  };

  const handleExpandTreeFolder = (event, nodeIds) => {
    setTreeExpanded(nodeIds);

    const newlyExpanded = nodeIds.filter((id) => !treeExpanded.includes(id));

    newlyExpanded.forEach((nodeId) => {
      const nodeObject = findObjectInChildren(treeData, nodeId);

      if (nodeObject && !nodeObject.children?.length) {
        if (nodeObject.isProjeto) {
          fetchDoczPastaList({
            idProjeto: nodeObject.id,
          });
        }
      }
    });
  };

  const handleChangeDocumentos = (event, newValue) => {
    setJsonConfig((prev) => ({
      ...prev,
      documentos: newValue,
    }));
  };

  const handleChangeMetadados = (event, index, fieldName) => {
    const { name, value, type, checked } = event.target;
    const metadados = jsonConfig?.[fieldName] || [];

    metadados[index] = {
      ...metadados[index],
      [name]: type === "checkbox" ? checked : value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      [fieldName]: metadados,
    }));
  };

  const addMetadados = (fieldName) => {
    const metadados = jsonConfig?.[fieldName] || [];

    if (fieldName === "metadados") {
      metadados.push({
        nome: "",
        valor: "",
        usarNaBusca: false,
        hidden: false,
        isDate: false,
      });
    } else {
      metadados.push({
        nome: "",
        valor: "",
        arquivo: "",
      });
    }

    setJsonConfig((prev) => ({
      ...prev,
      [fieldName]: metadados,
    }));
  };

  const removeMetadados = (event, index, fieldName) => {
    const metadados = jsonConfig?.[fieldName] || [];

    metadados.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      [fieldName]: metadados,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        bigHeight
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tabValue}
            indicatorColor="secondary"
            textColor="secondary"
            onChange={handleChangeTab}
          >
            <Tab label={language.properties} />
            <Tab label={language.configuration} />
            <Tab label={language.permissions} disabled />
          </Tabs>
        </Box>

        <FormPadding>
          <TabPanel value={tabValue} index={0}>
            <Grid container spacing={3}>
              <TabProperties
                businessObject={businessObject}
                taskFields={FormComponents}
                jsonConfig={jsonConfig}
                doczProjetoList={doczProjetoList}
                doczMetadadoList={doczMetadadoList}
                treeData={treeData}
                treeLoading={treeLoading}
                treeExpanded={treeExpanded}
                handleExpandTreeFolder={handleExpandTreeFolder}
                handleChangeProjeto={handleChangeProjeto}
                handleChangeConfigFields={handleChangeConfigFields}
                handleSelectTreeFolder={handleSelectTreeFolder}
                handleChangeDocumentos={handleChangeDocumentos}
                handleChangeMetadados={handleChangeMetadados}
                addMetadados={addMetadados}
                removeMetadados={removeMetadados}
              />
            </Grid>
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <TabConfiguration
              businessObject={businessObject}
              taskFields={FormComponents}
              jsonConfig={jsonConfig}
              doczMetadadoList={doczMetadadoList}
              handleChangeDocumentos={handleChangeDocumentos}
              handleChangeMetadados={handleChangeMetadados}
              addMetadados={addMetadados}
              removeMetadados={removeMetadados}
            />
          </TabPanel>
        </FormPadding>

        {hasConfigError && (
          <GenericSnackbar
            errorWithChildren={true}
            message={
              <div>
                {hasConfigError.map((err, index) => {
                  return <div key={`errorMessage_${index}`}>{err}</div>;
                })}
              </div>
            }
            handleClose={() => setHasConfigError(false)}
            duration={4000}
          />
        )}
      </GenericModal>
    )
  );
}

export default ModelerIntegrarDoczDocumento;
